export default __webpack_public_path__ + "static/media/hero.7f7e2e91.png";